import api from '@/api'
// import { COURSE_STATE } from '@/constant/constants'
export default {
  getChannelAddress ({ commit }, { channel }) {
    return api.channels.getChannelAddress({ cid: channel })
  },
  setViewHistory ({ commit }, { targetId }) {
    return api.channels.setViewHistory({ targetType: 1, targetId })
  },
  getChannelAddressTranscode ({ commit }, { channel }) {
    return api.channels.getChannelAddressTranscode({ cid: channel })
  },
  async getChannelAddressWithStatus ({ commit }, { channel }) {
    let address = {}
    let res = await api.channels.getChannelStatus({ cid: channel })
    if (res.status === 1 || res.status === 3) {
      address = await api.channels.getChannelAddress({ cid: channel })
    }
    return address
  },
  // async getAddressWithCourseId ({ commit }, { courseId, debugging }) {
  //   let address = {}
  //   let detail = await api.course.getCourseDetail({ courseId: courseId })
  //   if (detail.state === COURSE_STATE.LIVING || (debugging && detail.channel)) {
  //     let { status } = await api.channels.getChannelStatus({ cid: detail.channel })
  //     if (status === 1 || status === 3) {
  //       address = await api.channels.getChannelAddress({ cid: detail.channel })
  //     }
  //   }
  //   return { address, status, detail }
  // },
  getTranscode ({ commit }, { type, mixId }) {
    return api.channels.getTranscode({ type, mixId })
  },
  findCourseStatisticVo ({ commit }, { id }) {
    console.log(id,'aa')
    return api.course.findCourseStatisticVo(null, {paths: {id}})
  },
}
